import { defineStore } from 'pinia';
import { formModule } from '@/stores/form';

export const useAcknowledgementSettingsForm = defineStore('acknowledgementSettingsForm', () => formModule({
  fields: {
    company_name: { label: 'Company Name' },
    acknowledgement_email_intro: { label: 'Acknowledgement Email Intro' },
    acknowledgement_agreement_text: { label: 'Acknowledgement Agreement Text' },
    acknowledgement_pdf_text: { label: 'Acknowledgement PDF Text' },
    hr_contact_email: { label: 'HR Contact E-mail' },
    acknowledgement_cycle_sla: {
      label: 'Acknowledgement Cycle SLA',
      rules: [
        { name: 'positiveInteger', errorMessage: 'Must be a whole number (e.g. 7)' },
      ],
    },
    acknowledgement_pending_sla: {
      label: 'Acknowledgement Pending SLA',
      rules: [
        { name: 'positiveInteger', errorMessage: 'Must be a whole number (e.g. 7)' },
      ],
    },
  },
}));
